/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeRectHIcon20Regular = forwardRef('ShapeRectHIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.999 7.251a3.25 3.25 0 0 1 3.25-3.25h9.502a3.25 3.25 0 0 1 3.25 3.25v5.498a3.25 3.25 0 0 1-3.25 3.25H5.25a3.25 3.25 0 0 1-3.25-3.25V7.25Zm3.25-1.75a1.75 1.75 0 0 0-1.75 1.75v5.498c0 .966.783 1.75 1.75 1.75h9.502a1.75 1.75 0 0 0 1.75-1.75V7.25a1.75 1.75 0 0 0-1.75-1.75H5.25Z" })));
});
